import React from 'react';
import { Body7, Container } from '@ui';
import { TextField } from '@ui/inputs';
import { Consequence } from '@features/scoreSpec/styles';
import { isFork } from './naming';
import { errorsFor } from './validate';

// The name field, and the version the user is deliberately not allowed to type.
//
// `version` has to equal the `_v<N>` in the id, and create does not check that — lock does, on a
// spec that is frozen and has no unlock endpoint. So there is one number, this field derives it,
// and the resulting id is printed under the input as it is typed. Nothing that gets sent should be
// a surprise at the moment it is sent.

export const NameField = ({ value, onChange, errors, specId, sourceIdentity }) => {
  const messages = errorsFor(errors, 'stem');
  const fork = isFork(value, sourceIdentity);

  return (
    <div>
      <TextField
        id="duplicate-stem"
        label="Name"
        mono
        value={value}
        onChange={onChange}
        invalid={messages.length > 0}
        hint={messages[0] || 'Lowercase letters, digits and underscores. Leave the version off — it is added for you.'}
      />
      <Container top={8}>
        <Body7 isLowContrast>
          Will be created as <strong>{specId}</strong>
        </Body7>
      </Container>
      {/* Only the fork case says anything. Keeping the source's name is the DEFAULT path, and the
          derived id above already shows what it produces — a line restating it is noise on the
          screen every user sees. */}
      {fork && (
        <Container top={8}>
          <Consequence>
            {`A new name is a fork — a different question reusing ${sourceIdentity.stem}'s machinery — so the version resets to 1.`}
          </Consequence>
        </Container>
      )}
    </div>
  );
};
